//#region Libraries
//#endregion
//#region Styles
import { 
    Container,
    TDef } from "components/CustomTableList/components/TableListItem/ListItem/styles";
//#endregion
//#region Icons
import { 
    DateTimeCell, Cell } from "./styles";
//#endregion
//#region Utils
//#endregion

const TDEF_CONTENT_PROPS = {
    margin: "1px 0"
};

const TableListItem = ({
    penalizeDays, 
    endDate, details, 
    date, time,
    changes
}) => {
    //#region Functions
    const getClassNameCell = fieldIsChanged => {
        const classList = ["small", "ellipsis", "center"];
        fieldIsChanged && classList.push("changed");
        return classList.join(" ");
    }
    const getPropsForCell = fieldIsChanged => {
        return {
            ...TDEF_CONTENT_PROPS,
            className: getClassNameCell(fieldIsChanged)
        };  
    }
    //#endregion
    return (
        <Container>
            {penalizeDays &&
            <TDef>
                <Cell {...getPropsForCell(changes.penalizeDays)}>
                    <h5 title={penalizeDays}>{penalizeDays}</h5>
                </Cell>
            </TDef>}
            <TDef>
                <Cell {...getPropsForCell(changes.endDate)}>
                    <h5 title={endDate}>{endDate}</h5>
                </Cell>
            </TDef>
            <TDef>
                <Cell {...getPropsForCell(changes.details)}>
                    <h5 title={details}>{details || "-"}</h5>
                </Cell>
            </TDef>
            <TDef>
                <DateTimeCell {...getPropsForCell()}>
                    <h5 title={date}>{date}</h5>
                </DateTimeCell>
            </TDef>
            <TDef>
                <DateTimeCell {...getPropsForCell()}>
                    <h5 title={time}>{time}</h5>
                </DateTimeCell>
            </TDef>
        </Container>
    );
}

export default TableListItem;